import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const ImageNormalIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\uefa2'}</MuiIcon>
    );
}
